import React, { Component } from "react"
import './index.css';
import ColoredTD from './colored_td.js'
import ReactLoading from 'react-loading';
import moment from 'moment';
import store from "./store/index";
import ColoredBoxes from './components/UI/ColoredBoxes'
import RunnerMetaData from './components/UI/ToolTip'
import WinnerBox from './components/UI/WinnerBox'
import BfLogin from './bfLogin'
import { getLoginToken, ODD_API, updateBetId } from "./constants/utils";
import axios from "axios";
import { Form } from 'react-bootstrap'
import BfQuickResult from "./bfQuickResult";
import ComputerSelectionPanels from './ComputerSelectionPanels';
import { updateBetMarket } from "./actions";
import horseIcon from './assets/horse_icon.jpg';
import harnessIcon from './assets/harness_icon.jpg';

const textStyle1 = {
  fontSize: '12px',
}

const runnerNameDiv = { alignItems: 'baseline', display: 'flex' }

const alignCenter = {
  align: "center",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block"

}

const marginStyle = {
  marginTop: '20px',
}
const headStyle1 = {
  color: '#21ffe4',
  fontSize: '13px',
  marginLeft: '20px',
  fontfamily: 'Roboto',
  display: 'inline-block',
  fontWeight: 'bold',
  width: '65%',
  marginTop: '10px'
};
const headStyle2 = {
  color: 'rgb(247, 246, 198)',
  fontSize: '12px',
  fontfamily: 'Roboto',
  display: 'inline-block',
  fontWeight: 'bold',
  marginTop: '10px',
  float: 'right',
  marginRight: '25px'
};

const runnersCount = {
  textAlign: 'right',
}

const responseBody = {
  "marketOdds": []
}

const postRequestPara = {
  "marketIds": [
    "1.156717370"
  ],
  "timePoints": [
    "t1-20190327-13:55:00",
    "t2-20190327-14:10:00",
    "t3-20190327-14:40:00",
    "t4-20190327-14:45:00",
    "t5-20190327-14:50:00",
    "t6-20190327-14:55:00"
  ]
}

class RightTable extends Component {
  timer = null;

  constructor(props) {
    super(props)
    this.state = {
      runnersOddsAtTimes: {
        test: "test",
      },
      timeDifference: null,
      suspended: false,
      marketId: null,
      inPlayStartTimes: {},
      showCountryTotal: false,
    };
  }

  selectBetMarket = async (selectedMarketName, selectedMarketId) => {
    store.dispatch(updateBetMarket({ "marketId": selectedMarketId, "type": selectedMarketName }));
    if (this.props.onMarketChange) {
      this.props.onMarketChange();
    }
  }

  fetchRaceStatus = () => {
    const marketId = this.props.marketId
    const token = getLoginToken();
    if (marketId && token) {
      const postRequestPara = {
        "requests":
          [{ "marketId": marketId, "selectionId": 1234567 }],
        "ssoid": token,
      }
      axios.post(ODD_API, postRequestPara)
        .then((res) => {
          const oddDetails = res.data
          if (oddDetails && oddDetails.length > 0) {
            //console.log("vivek" + JSON.stringify(oddDetails[0]))
            this.setState({ suspended: oddDetails[0].status != 'OPEN' });
            var inPlayStartTimes = this.state.inPlayStartTimes;
            if (oddDetails[0].inplay && !inPlayStartTimes[marketId]) {
              inPlayStartTimes[marketId] = moment().utcOffset(store.getState().localTimeOffSetToGmt);
              this.setState({ inPlayStartTimes: inPlayStartTimes });
            }
            if (oddDetails[0].status == 'SUSPENDED' || oddDetails[0].status == 'CLOSED') {
              delete inPlayStartTimes[marketId]
            }
          }
        },
          (error) => {
            //console.log("Result of API 3 returns Error!!!" + error)
          });
    }
  }

  getTime(hour, minute, seconds, textCOlor) {
    return <div style={{ color: textCOlor }}>Time Until Start: {hour + ":" + minute + ":" + seconds}</div>
  }

  displayRaceStatus = () => {
    //Dont update timer for suspended race.

    this.setState({ marketId: this.props.marketId })

    const raceStartTimeInLocal = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')
    const currentTime = moment().utcOffset(store.getState().localTimeOffSetToGmt)
    var hrs = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("HH");
    var min = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("mm");
    var sec = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("ss");
    const diff = raceStartTimeInLocal.diff(currentTime);
    const inPlayStartTime = this.state.inPlayStartTimes ? this.state.inPlayStartTimes[this.props.marketId] : null
    //not between in play zone
    if (!inPlayStartTime || inPlayStartTime === null) {
      if (diff > 0) {
        //Normal case race yet to start
        const diff = <div style={{ color: "#08e64f" }}>Time Until Start: {hrs + ":" + min + ":" + sec}</div>
        this.setState({ timeDifference: diff });
      } else {
        //Race past in play i.e its suspended.
        var hrs = moment.utc(currentTime.diff(raceStartTimeInLocal)).format("HH");
        var min = moment.utc(currentTime.diff(raceStartTimeInLocal)).format("mm");
        var sec = moment.utc(currentTime.diff(raceStartTimeInLocal)).format("ss");
        const diffAfterRaceStarts = <div style={{ color: "#a80909" }}>Time Until Start: -{hrs + ":" + min + ":" + sec}</div>
        this.setState({ timeDifference: diffAfterRaceStarts });
      }
    } else {
      //Mark Green for In Play Match. Difference would be (current time - when in pplay started)
      const inPlayStartTime = this.state.inPlayStartTimes[this.props.marketId]
      var hrs = moment.utc(currentTime.diff(inPlayStartTime)).format("HH");
      var min = moment.utc(currentTime.diff(inPlayStartTime)).format("mm");
      var sec = moment.utc(currentTime.diff(inPlayStartTime)).format("ss");
      const diffFromInPlay = <div style={{ color: "#08e64f" }}>Time Until Start: {hrs + ":" + min + ":" + sec}</div>
      this.setState({ timeDifference: diffFromInPlay });
    }
  }
  async componentDidMount() {
    this.timer = setInterval(
      () => {
        this.fetchRaceStatus();
        this.displayRaceStatus();
      },
      1000,
    );
  }
  componentWillUnmount() {
    //clearTimeout(this.timer);
  }

  convertGMTtoLocalTime = gmtTime => {
    if (gmtTime !== null) {
      return moment(gmtTime)
    }
    return null;
  };

  getTotalMatched = () => {
    let totalMatched = 0
    this.props.secondItem.forEach(runnerElement => {
      const matchedValue = runnerElement.volumeMatched ? runnerElement.volumeMatched : 0
      totalMatched += matchedValue
    }
    )
    return totalMatched.toFixed(0)
  }

  getOverRound = () => {
    let result = 0
    this.props.secondItem.forEach(runnerElement => {
      const currentPrice = runnerElement.currentPrice ? runnerElement.currentPrice : 0
      if (currentPrice > 1) {
        result += 100 / currentPrice
      }
    }
    )
    return result.toFixed(2)
  }

  getActiveRunners = () => {
    let result = 0
    this.props.secondItem.forEach(runnerElement => {
      if (runnerElement.status === 'ACTIVE') {
        result++
      }
    }
    )
    return result
  }

  numberStyles = {
    color: '#f4e1f0'
  }

  getLabel = (marketName, winnercount) => {
    if (winnercount) {
      return marketName + "(Winners:" + winnercount + ")";
    }
    return marketName;
  }


  getMarkets = () => {
    var supressedMarket = ["EXACTA", "QUINELLA", "PLACE:3", "WIN", "MATCH_BET", "Exacta", "Quinella", "PLACE:2", "PLACE:3", "OTHER_PLACE:3"];
    var filterUnused = (market) => {
      return !supressedMarket.includes(market);
    }
    var marketList = this.props.firstItem.marketInfoMarketId;
    var winnerCount = this.props.firstItem.marketWinnerCount;
    if (!marketList) {
      return;
    }
    var sortMarket = (a, b) => {
      var sortOrder = {
        "Win": 1,
        "Each Way": 2,
        "To Be Placed": 3,
        "2 TBP": 4,
        "3 TBP": 5,
        "4 TBP": 6,
        "5 TBP": 7,
        "6 TBP": 8
      }
      if (sortOrder[a] && sortOrder[b]) {
        return sortOrder[a] - sortOrder[b];
      } else {
        return 0;
      }
    }
    var selectedMarket = store.getState().betMarket.type;
    return <>{Object.keys(marketList).sort(sortMarket).filter(filterUnused).map(x => <Form.Check
      type='radio'
      checked={selectedMarket === x}
      name="group1"
      label={this.getLabel(x, winnerCount[x])}
      style={{ marginLeft: "5px" }}
      onChange={(checked) => { this.selectBetMarket(x, marketList[x]) }}
    />)}</>;
  }



  render() {

    const raceStartTimeInLocal = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')
    const currentRaceInLocalTime = raceStartTimeInLocal.format('YYYY-MM-DD HH:mm');
    const currentTime = moment().utcOffset(store.getState().localTimeOffSetToGmt)

    //console.log("RIght table updated with new value :: " + this.props.firstItem);
    //console.log("Runners count :: " + this.props.secondItem.length);
    let date = String(this.props.firstItem["date"])
    //console.log("date : dfdf " + date);
    var tableHeader = <p class="font-weight-bold" style={headStyle1}>Selected Race:  Loading ... wait.. </p>
    let aiSummary = null
    if (date !== "undefined") {
      const latestOddsTime = this.convertGMTtoLocalTime(this.props.firstItem['latestOddTimestamp']);
      // let raceDelayed = false;
      // if(latestOddsTime > raceStartTimeInLocal) raceDelayed = true;
      //console.log("latestOddsTime:" + latestOddsTime)
      const s = this.props.aiRankStats
      const useTotal = this.state.showCountryTotal
      const sDisplay = s && (useTotal
        ? (s.total && s.total.rank1 ? s.total : null)
        : (s.horseOnly && s.horseOnly.rank1 ? s.horseOnly : (s.total && s.total.rank1 ? s.total : null)))
      const iconStyle = { width: '20px', height: '20px', marginRight: '2px' }
      const sLabel = s && (useTotal
        ? <span><img src={horseIcon} alt="Horse" style={iconStyle} /><img src={harnessIcon} alt="Harness" style={iconStyle} />({s.country})</span>
        : (s.horseOnly && s.horseOnly.rank1
            ? <span><img src={horseIcon} alt="Horse" style={iconStyle} />({s.country})</span>
            : <span><img src={horseIcon} alt="Horse" style={iconStyle} /><img src={harnessIcon} alt="Harness" style={iconStyle} />({s.country})</span>))
      const hasHorseOnly = s && s.horseOnly && s.horseOnly.rank1
      const excludedCountries = ['FR', 'US']
      aiSummary = sDisplay && s && !excludedCountries.includes(s.country) ? (
        <div style={{ padding: '3px 20px', display: 'flex', alignItems: 'center' }}>
          <a
            href={`https://rpmapi.makebettinggreat.com/v1/horse/ai-report/${date}/download`}
            download={`Daily-AI-Winners-${date.replace(/-/g, '')}`}
            style={{ color: '#ffdd57', fontWeight: 'bold', marginRight: '12px', fontSize: '14px', textDecoration: 'underline', cursor: 'pointer', letterSpacing: '0.5px' }}
          >Daily AI Winners</a>
          <span style={{ color: '#21ffe4', fontSize: '12px', marginRight: '10px' }}>AI Rank 1: <b>{sDisplay.rank1.hitPct}%</b> win, avg <b>{sDisplay.rank1.avgOdds}</b></span>
          <span style={{ color: 'rgba(33,255,228,0.75)', fontSize: '12px', marginRight: '10px' }}>| AI Rank 2: <b>{sDisplay.rank2.hitPct}%</b> win, avg <b>{sDisplay.rank2.avgOdds}</b></span>
          <span style={{ color: 'rgba(33,255,228,0.55)', fontSize: '12px', marginRight: '14px' }}>| AI Rank 3: <b>{sDisplay.rank3.hitPct}%</b> win, avg <b>{sDisplay.rank3.avgOdds}</b></span>
          {hasHorseOnly && s.country === 'AU' && (
            <label style={{ color: '#fff', fontSize: '13px', fontWeight: 'bold', marginBottom: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', background: '#e67e22', padding: '2px 8px', borderRadius: '4px', border: '1px solid #ca6f1e' }}>
              <input
                type="checkbox"
                checked={this.state.showCountryTotal}
                onChange={e => this.setState({ showCountryTotal: e.target.checked })}
                style={{ cursor: 'pointer', width: '14px', height: '14px' }}
              />
              Includes Harness
            </label>
          )}
        </div>
      ) : null
      tableHeader = <p class="font-weight-bold" style={headStyle1}>
        <span id="selectedMarketDetails">{currentRaceInLocalTime} - {this.props.firstItem["venue"]} - {this.props.firstItem["marketName"]}</span>
        <span style={{ color: 'rgb(247, 246, 198)' }}>{"  -  (Last odds update at - " + latestOddsTime.format('HH:mm:ss') + ")"}</span>
        <span style={{ color: 'rgb(247, 246, 198)', fontSize: "14px", marginRight: "50px", float: "right", display: "flex" }}>
          {this.state.timeDifference}
          {this.getMarkets()}
        </span>
      </p>
    }

    let loadingElement = null
    let keysArray = Object.keys(this.props.secondItem)
    //console.log("LOADING STILL intial Right table: " + keysArray.length);
    if (keysArray.length > 0) {
      //console.log("LOADING STILL finised dfdfdfd ghgh ");
      loadingElement = null
    } else {
      //console.log("LOADING STILL");
      loadingElement = <ReactLoading type="bars" color="green" width={200} height={200} className="alignCenter24" />

    }

    let colSpan = 1
    let thStyle = {}
    if (this.props.displayTicks) {
      colSpan = 2
      thStyle = {
        textAlign: 'center'
      }
    }

    return (
      <div class="divStyle1">
        <div>
          {tableHeader}
          {aiSummary}
          <div style={headStyle2}>
            <p class="wefw"><span>Overround: <span style={this.numberStyles}>{this.getOverRound()}</span></span>&nbsp;&nbsp;<span>Matched: $<span style={this.numberStyles}>{this.getTotalMatched()}</span></span>&nbsp;&nbsp;<span>Runners: </span><span style={this.numberStyles}>{this.getActiveRunners()}/{Object.keys(this.props.secondItem).length}</span></p>
          </div>
        </div>
        <div class="blockSize2 blockSpacing">
          <table class="table table-striped table-light" style={{...textStyle1, marginBottom: '3px'}} id="runner_Odds_Table" >
            <thead>
              <tr>
                <th scope="col">Runner</th>
                <th scope="col">AI Rank</th>
                <th scope="col" colSpan="2" style={{ textAlign: "center" }}>Current Price</th>
                <th scope="col" style={{ display: 'none' }} data-export="Win/Place">Win/Place</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T1</th>
                <th scope="col">T1 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T2</th>
                <th scope="col">T2 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T3</th>
                <th scope="col">T3 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T4</th>
                <th scope="col">T4 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T5</th>
                <th scope="col">T5 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T6</th>
                <th scope="col">T6 Price</th>
                <th scope="col" data-skip-export="true">Bets({this.state.selectedMarketName})</th>
              </tr>
            </thead>
            <tbody>
              {
                { runner: "john", currentPrice: "23.4", t1: "n/a", t1Price: "", t2: "n/a", t2Price: "", t3: "n/a", t3Price: "", t4: "n/a", t4Price: "", t5: "n/a", t5Price: "", t6: "n/a", t6Price: "" },

                this.props.secondItem.map(runnerElement => {
                  let winnerInfo = null;
                  let exportWinPlace = '';
                  if (this.props.winnerInfo !== null && this.props.winnerInfo !== "") {
                    if (this.props.winnerInfo.winner === runnerElement.selectionId) {
                      winnerInfo = <WinnerBox type="W" />
                      exportWinPlace = 'Win';
                    }

                    if (this.props.winnerInfo.places !== null && this.props.winnerInfo.places.length > 0) {
                      if (this.props.winnerInfo.places.includes(runnerElement.selectionId)) {
                        winnerInfo = <WinnerBox type="P" />
                        exportWinPlace = 'Place';
                      }
                    }
                  }

                  return (
                    <tr key={runnerElement.name}>
                      <td className="RunnerMetaData" data-export={runnerElement.metadata && runnerElement.metadata["CLOTH_NUMBER_ALPHA"] && !runnerElement.name.startsWith(runnerElement.metadata["CLOTH_NUMBER_ALPHA"]) ? `${runnerElement.metadata["CLOTH_NUMBER_ALPHA"]}. ${runnerElement.name}` : runnerElement.name}>
                        <RunnerMetaData metadata={runnerElement.metadata} volumeMatched={runnerElement.volumeMatched} />
                        <div style={runnerNameDiv}><div>{runnerElement.metadata && runnerElement.metadata["CLOTH_NUMBER_ALPHA"] && !runnerElement.name.startsWith(runnerElement.metadata["CLOTH_NUMBER_ALPHA"]) ? `${runnerElement.metadata["CLOTH_NUMBER_ALPHA"]}. ${runnerElement.name}` : runnerElement.name}</div>{winnerInfo}</div>
                      </td>
                      <td>{runnerElement.status === 'ACTIVE' ? (runnerElement.predictionRank || '-') : '-'}</td>
                      <td style={{ paddingRight: 0 }}>{runnerElement.currentPrice}</td>
                      <td style={{ paddingLeft: 0 }} data-skip-export="true"><ColoredBoxes runnerElement={runnerElement} /></td>
                      <td style={{ display: 'none' }} data-export={exportWinPlace}></td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t1} priceAtTime={runnerElement.t1Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t1Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t2} priceAtTime={runnerElement.t2Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t2Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t3} priceAtTime={runnerElement.t3Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t3Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t4} priceAtTime={runnerElement.t4Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t4Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t5} priceAtTime={runnerElement.t5Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t5Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t6} priceAtTime={runnerElement.t6Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t6Price}</td>
                      <td scope="col" data-skip-export="true">
                        <BfLogin
                          marketId={this.props.marketId}
                          marketName={this.props.firstItem}
                          suspended={this.state.suspended}
                          selectionId={runnerElement.selectionId}
                          runner={runnerElement}
                          odd={runnerElement.currentPrice}>
                        </BfLogin></td>

                    </tr>
                  )
                }
                )
              }
            </tbody>
          </table>
          {this.props.verdict && Array.isArray(this.props.verdict) && (this.props.verdict[1] || this.props.verdict[0]) && Object.keys(this.props.secondItem).length > 0 && (
            <div style={{ marginTop: '0px', padding: '10px 16px', background: 'linear-gradient(90deg, #1a3a2a, #0d1f17)', border: '1px solid #00e676', borderLeft: '4px solid #00e676', borderRadius: '4px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#00e676', fontWeight: 'bold', fontSize: '13px', whiteSpace: 'nowrap' }}>&#127942; Market Tips(TF):</span>
              <span style={{ color: '#f0f0f0', fontSize: '13px', letterSpacing: '0.3px' }}>{(this.props.verdict[1] || this.props.verdict[0]).verdictTip}</span>
            </div>
          )}
          <ComputerSelectionPanels bfMarketId={this.props.marketId} />
          <div>
            {getLoginToken() ?
              <BfQuickResult marketId={this.props.marketId} showDateDropDown="false" refreshTime="2000"
                type="current" filterStatus="EXECUTABLE"></BfQuickResult>
              : null
            }
          </div>
          <div style={alignCenter}>
            {loadingElement}
          </div>
        </div>
      </div>


    )
  }
}
export default RightTable
